import { Button } from "@/components/ui/button";
import PlanSelection from "@/features/payments/containers/plans";
import CancelSubscriptionDialog from "../containers/cancel-subscription-dialog";
import ModifySubscriptionDialog from "../containers/modify-subscription-dialog";
import useManageMembership from "../hooks/use-manage-membership";

function ProfileManageMembershipPage() {
	const {
		currentSubscription,
		currentPlan,
		onPlanSelected,

		showModifySubscriptionDialog,
		setShowModifySubscriptionDialog,
		onModifySubscription,

		toggleShowCancelSubscriptionDialog,
		showCancelSubscriptionDialog,
		setShowCancelSubscriptionDialog,
		onCancelSubscription,
	} = useManageMembership();

	return (
		<div className="flex flex-col items-center justify-center gap-14">
			{currentSubscription?.status === "active" && (
				<CancelSubscriptionDialog
					showCancelSubscriptionDialog={showCancelSubscriptionDialog}
					setShowCancelSubscriptionDialog={setShowCancelSubscriptionDialog}
					onCancelSubscription={onCancelSubscription}
				/>
			)}

			<ModifySubscriptionDialog
				showModifySubscriptionDialog={showModifySubscriptionDialog}
				setShowModifySubscriptionDialog={setShowModifySubscriptionDialog}
				onModifySubscription={onModifySubscription}
			/>

			<PlanSelection
				header={
					<p className="web-heading-h3-medium text-center">Manage Membership</p>
				}
				footer={!currentPlan && <div className="max-sm:h-[160px]"></div>}
				currentSubscription={currentSubscription}
				currentPlan={currentPlan}
				onPlanSelected={onPlanSelected}
			/>

			{currentSubscription?.status === "active" && (
				<Button
					variant={"secondary"}
					onClick={toggleShowCancelSubscriptionDialog}
				>
					Cancel membership
				</Button>
			)}
		</div>
	);
}

export default ProfileManageMembershipPage;
